import React, { useState, useEffect } from "react";
import TabSelector from "globalComponents/TabSelector/TabSelector";

export default function TaskTypeSelector(props) {
  const {
    taskType,
    setTaskType,
    itemDay,
    setItemDay,
    activeDate,
    setActiveDate,
    dateHelper,
  } = props;

  const [onDateSelected, setOnDateSelected] = useState(
    activeDate && activeDate.getTime() === itemDay.getTime()
  );
  useEffect(() => {
    if (onDateSelected && taskType === "flexible") {
      setTaskType("critical");
    }
  }, [onDateSelected]);

  useEffect(() => {
    if (taskType === "flexible") {
      setOnDateSelected(false);
    }
  }, [taskType]);

  useEffect(() => {
    if (
      onDateSelected &&
      itemDay &&
      activeDate &&
      itemDay.getTime() !== activeDate.getTime()
    ) {
      setOnDateSelected(false);
    }
  }, [itemDay, activeDate]);

  useEffect(() => {
    if (
      activeDate &&
      itemDay.getTime() === activeDate.getTime() &&
      taskType == "critical"
    ) {
      setOnDateSelected(true);
    }
  }, [activeDate, taskType]);

  const options = ["flexible", "critical"];

  function handleOnDayClick() {
    setOnDateSelected(!onDateSelected);
    if (!onDateSelected) {
      if (itemDay.getFullYear() === 5000) {
        const date = activeDate || dateHelper.date;
        setActiveDate(date);
        setItemDay(date);
      } else {
        setActiveDate(itemDay);
      }
    }
  }

  function onDayButtonClassNames() {
    let result = "on-date-button";
    if (onDateSelected) {
      result += " selected";
    }
    return result;
  }

  return (
    <div className="task-type-selector-container">
      <TabSelector
        optionContents={options}
        shape="round"
        options={options}
        selectedOption={taskType}
        setSelectedOption={setTaskType}
      />
      <button className={onDayButtonClassNames()} onClick={handleOnDayClick}>
        on-date
      </button>
    </div>
  );
}
